const premiumCards = Array.from(document.querySelectorAll('[data-home-premium-card]'));

if (premiumCards.length > 0) {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  premiumCards.forEach((card) => {
    card.style.setProperty('--home-reveal-delay', '0ms');
    card.setAttribute('data-home-premium-reveal', prefersReducedMotion ? 'visible' : 'pending');
  });

  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top);

        visibleEntries.forEach((entry, index) => {
          entry.target.style.setProperty('--home-reveal-delay', `${index * 140}ms`);
          entry.target.setAttribute('data-home-premium-reveal', 'visible');
          observer.unobserve(entry.target);
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -4% 0px',
      }
    );

    premiumCards.forEach((card) => observer.observe(card));
  } else {
    premiumCards.forEach((card) => card.setAttribute('data-home-premium-reveal', 'visible'));
  }
}
